
import { useState, useEffect } from 'react';

const Header = () => {
  const [activeSection, setActiveSection] = useState('inicio');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['inicio', 'sobre', 'curso', 'galeria', 'depoimentos', 'pagamento', 'contato'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;
          
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      const headerOffset = 450; // Altura do header + espaço extra
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    // Fecha o menu mobile ao clicar em um link
    setMobileMenuOpen(false);
  };

  return (
    <header className="text-gray-900 shadow-lg sticky top-0 z-50" style={{ background: 'linear-gradient(to right, #E18E37, #C67A2A)' }}>
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img 
              src="/images/unnamed.png" 
              alt="Aprenda Elétrica Residencial" 
              className="h-10 w-10 object-contain"
            />
            <h1 className="text-2xl font-bold">Aprenda Elétrica Residencial</h1>
          </div>

          {/* Menu Desktop */}
          <div className="hidden md:flex space-x-6 items-center">
            <a 
              href="#inicio" 
              onClick={(e) => handleSmoothScroll(e, 'inicio')} 
              className={`hover:text-white transition-colors font-medium ${activeSection === 'inicio' ? 'text-white border-b-2 border-white' : ''}`}
            >
              Início
            </a>
            <a 
              href="#sobre" 
              onClick={(e) => handleSmoothScroll(e, 'sobre')} 
              className={`hover:text-white transition-colors font-medium ${activeSection === 'sobre' ? 'text-white border-b-2 border-white' : ''}`}
            >
              Sobre
            </a>
            <a 
              href="#curso" 
              onClick={(e) => handleSmoothScroll(e, 'curso')} 
              className={`hover:text-white transition-colors font-medium ${activeSection === 'curso' ? 'text-white border-b-2 border-white' : ''}`}
            >
              Curso
            </a>
            <a 
              href="#galeria" 
              onClick={(e) => handleSmoothScroll(e, 'galeria')} 
              className={`hover:text-white transition-colors font-medium ${activeSection === 'galeria' ? 'text-white border-b-2 border-white' : ''}`}
            >
              Galeria
            </a>
            <a 
              href="#depoimentos" 
              onClick={(e) => handleSmoothScroll(e, 'depoimentos')} 
              className={`hover:text-white transition-colors font-medium ${activeSection === 'depoimentos' ? 'text-white border-b-2 border-white' : ''}`}
            >
              Depoimentos
            </a>
            <a 
              href="#contato" 
              onClick={(e) => handleSmoothScroll(e, 'contato')} 
              className={`hover:text-white transition-colors font-medium ${activeSection === 'contato' ? 'text-white border-b-2 border-white' : ''}`}
            >
              Contato
            </a>
            <a 
              href="#pagamento" 
              onClick={(e) => handleSmoothScroll(e, 'pagamento')} 
              className={`px-4 py-2 rounded-lg font-bold transition-all transform hover:scale-105 ${
                activeSection === 'pagamento' 
                  ? 'bg-white text-gray-900 border-2 border-white' 
                  : 'border-2 border-white text-white hover:bg-white hover:text-gray-900'
              }`}
            >
              COMPRAR AGORA
            </a>
          </div>

          {/* Botão Hambúrguer Mobile */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-gray-900 focus:outline-none"
            aria-label="Menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {mobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Menu Mobile */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
            mobileMenuOpen ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="flex flex-col space-y-3 pb-4">
            <a
              href="#inicio"
              onClick={(e) => handleSmoothScroll(e, 'inicio')}
              className={`px-4 py-2 rounded transition-colors font-medium ${
                activeSection === 'inicio' ? 'bg-white text-gray-900' : 'hover:bg-white hover:text-gray-900'
              }`}
            >
              Início
            </a>
            <a
              href="#sobre"
              onClick={(e) => handleSmoothScroll(e, 'sobre')}
              className={`px-4 py-2 rounded transition-colors font-medium ${
                activeSection === 'sobre' ? 'bg-white text-gray-900' : 'hover:bg-white hover:text-gray-900'
              }`}
            >
              Sobre
            </a>
            <a
              href="#curso"
              onClick={(e) => handleSmoothScroll(e, 'curso')}
              className={`px-4 py-2 rounded transition-colors font-medium ${
                activeSection === 'curso' ? 'bg-white text-gray-900' : 'hover:bg-white hover:text-gray-900'
              }`}
            >
              Curso
            </a>
            <a
              href="#galeria"
              onClick={(e) => handleSmoothScroll(e, 'galeria')}
              className={`px-4 py-2 rounded transition-colors font-medium ${
                activeSection === 'galeria' ? 'bg-white text-gray-900' : 'hover:bg-white hover:text-gray-900'
              }`}
            >
              Galeria
            </a>
            <a
              href="#depoimentos"
              onClick={(e) => handleSmoothScroll(e, 'depoimentos')}
              className={`px-4 py-2 rounded transition-colors font-medium ${
                activeSection === 'depoimentos' ? 'bg-white text-gray-900' : 'hover:bg-white hover:text-gray-900'
              }`}
            >
              Depoimentos
            </a>
            <a
              href="#contato"
              onClick={(e) => handleSmoothScroll(e, 'contato')}
              className={`px-4 py-2 rounded transition-colors font-medium ${
                activeSection === 'contato' ? 'bg-white text-gray-900' : 'hover:bg-white hover:text-gray-900'
              }`}
            >
              Contato
            </a>
            <a
              href="#pagamento"
              onClick={(e) => handleSmoothScroll(e, 'pagamento')}
              className="px-4 py-3 rounded-lg font-bold bg-white text-gray-900 border-2 border-white text-center hover:bg-gray-100 transition-colors"
            >
              COMPRAR AGORA
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
